.homeWrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #eeeeee;
}

// EPPR2-3142: preview Index must fit header + cover + CTA + bottom bar in one
// viewport with no scroll and the bar always visible. Pin the wrapper to the
// viewport (dvh handles mobile browser chrome), let the content area shrink,
// and cap the cover so it leaves room for the bottom bar (which is in-flow as
// the last flex child, not sticky).
.previewMode {
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}

// Cover area takes the leftover space between the header and the pinned CTA +
// bottom bar (both flex-shrink:0 siblings below). overflow:hidden means an
// over-tall cover clips here instead of pushing the CTA/bar off-screen — the
// CTA and bar live OUTSIDE this box, so they are always visible regardless of
// viewport height (this is what makes the layout viewport-independent).
.previewMode .homeContainer,
.previewMode .multiTitleIssueContainer {
  flex: 1;
  min-height: 0;
  height: auto;
  overflow: hidden;
}

.previewMode .readerViewContainer {
  min-height: 0;
  padding-top: 16px;
}

// Keep the cover within its area so it isn't clipped by the overflow:hidden
// above. The CTA + bar are pinned outside this box, so this cap is only about
// the cover looking whole, not about button visibility. Selector carries the
// extra .homeWrapper class (specificity 0,3,1) to beat IssueContainer's own
// cover cap `.placeHolderWrapper .imageWrapper .mutilTitleIssue { max-height:
// calc(100vh - 270px) }` (0,3,0) — without it this override loses the cascade.
// Reserve 400px = header/tabs (~110) + date/padding (~66) + pinned CTA (~90) +
// bottom bar (~115) + breathing room.
.previewMode.homeWrapper .readerViewContainer img,
.previewMode.homeWrapper .readerViewContainer svg {
  max-height: calc(100dvh - 400px);
  max-width: 100%;
}

// Preview CTA, lifted out of the scrolling cover area so it (and the bottom
// bar below it) is always visible. flex-shrink:0 keeps it at its natural height
// while the cover area above absorbs all remaining space.
.previewMode.homeWrapper .previewCta {
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  padding: 12px 24px 20px;
}

.previewCtaBtn {
  background: var(--brand-button-color);
  border: 0;
  border-radius: 30px;
  color: #fff;
  cursor: pointer;
  font-family: var(--brand-button-font-family);
  font-size: var(--brand-button-font-size);
  font-weight: var(--brand-button-font-weight);
  min-width: 160px;
  padding: 16px 28px;
  text-transform: uppercase;
}

.previewCtaBtn:hover {
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.15);
}

.hideHomeContainer {
  visibility: hidden;
}

.homeContainer {
  display: flex;
}

.multiTitleIssueContainer {
  height: calc(100vh - 110px);
}

.readerViewContainer {
  flex: 1;
  padding-top: 60px;
}

.hideReaderView {
  flex: 0.4;
}

.tileViewWrapper {
  -ms-overflow-style: none; /* IE and Edge */
  background-color: #fafafa;
  flex: 0.6;
  max-height: calc(100vh - 61px);
  overflow-y: auto;
}

.dateContainer div {
  text-align: center;
}

.dateContainer .dayTxt {
  color: var(--brand-day-color);
  font-family: var(--brand-day-font-family);
  font-size: var(--brand-day-date-font-size);
  font-style: normal;
  letter-spacing: 0.8px;
  line-height: 100%; /* 16px */
  text-transform: uppercase;
}

.dateContainer .dateTxt {
  color: var(--brand-date-color);
  font-family: var(--brand-date-font-family);
  font-size: var(--brand-day-date-font-size);
  font-style: normal;
  line-height: 100%;
  margin-top: 4px;
}

.pubsRow {
  display: flex;
  justify-content: center;
  text-align: center;
}

@media screen and (max-height: 1050px) {
  .readerViewContainer {
    padding: 22px 0;
  }
}

//css for hide reader view for mobile device when tile view is visible
@media screen and (max-width: 1000px) {
  .tileViewWrapper,
  .readerViewContainer {
    flex: 1;
  }

  .hideReaderView {
    display: none;
  }

  .tileViewWrapper {
    max-height: 100%;
  }
}
